import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import { Link } from "react-router-dom";
import WOW from "wowjs";
import { FaLongArrowAltRight } from "react-icons/fa";
import axios from 'axios';
import { Row, Col } from "reactstrap";

 function GetPeople(props) {
    
    const [peopleList , setPeopleList] = useState([])
    
  useEffect(()=>{
    let _obj = new Object()
    _obj.people_ps_category_id = props.subcategory_id
    _obj.people_status = 1
    axios.post(global.variables.strApiUrl + "/peopleApi/getpeopleList",_obj)
    .then((response_peopleList)=>{
        if(response_peopleList.data === 'error')
        {
          props.history('/error-page')
        }
        else
        {
            if(response_peopleList.data[0][0]?.people_ps_category_id === props.subcategory_id)
            {
                setPeopleList(response_peopleList.data[0])
            }
        }
    })
  },[props.subcategory_id])
  
  useEffect(() => {
        
    
    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();

  }, [peopleList]);

  return (
            props.getPerticularpeopleCategory[0]?.psubcategory_count === 1 ?
                <div className="p-md-3 py-3">
                    <Row className="row-cols-1 row-cols-lg-2 g-lg-4 gy-4 people">
                        {
                        peopleList?.map((val_people)=>{
                            return(
                            
                            <Col className="px-4">
                                {
                                    val_people.people_url != '' && val_people.people_url != null ?
                                        <Link to={val_people.people_url} target="_blank" rel="nofollow">
                                            <Row className="bg-light rounded-3 _border p-3 px-1 h-100">
                                            <Col md={4} className="mb-md-0 mb-2">
                                                {
                                                val_people.people_pic != '' ?
                                                    <img src={global.variables.strApiUrl + "/people/" + val_people.people_pic} className="img-fluid" alt={val_people.people_salutation != '' ? `${val_people.people_salutation} ${val_people.people_name}`: val_people.people_name} title={val_people.people_salutation != '' ? `${val_people.people_salutation} ${val_people.people_name}`: val_people.people_name} width="200" height="200" />
                                                :
                                                    <img src={global.variables.strDomainUrl + "images/people/people-default.jpg"} className="img-fluid" alt="" title="" width="200" height="200" />
                                                }
                                            </Col>
                                            <Col md={8} className="d-flex flex-column">
                                                {
                                                    val_people.people_salutation != '' ?
                                                    <h5 className="text-dark mb-0 wow fadeInUp">{`${val_people.people_salutation} ${val_people.people_name}`}</h5>
                                                    :
                                                    <h5 className="text-dark mb-0 wow fadeInUp">{val_people.people_name}</h5>
                                                }
                                                <p className="wow fadeInUp">
                                                <span dangerouslySetInnerHTML={{ __html : val_people.people_designation}}></span>
                                                </p>
                                                <p className="mb-0 mt-auto wow fadeInUp">
                                                <span className="btn btn-slide rounded-pill px-3 align-items-center d-inline-flex">
                                                    View Profile<FaLongArrowAltRight className="ms-2" />
                                                </span>
                                                </p>
                                            </Col>
                                            </Row>
                                        </Link>
                                    :
                                        <Row className="bg-light rounded-3 _border p-3 px-1 h-100">
                                            <Col md={4} className="mb-md-0 mb-2">
                                                {
                                                val_people.people_pic != '' && val_people.people_pic != null ?
                                                    <img src={global.variables.strApiUrl + "/people/" + val_people.people_pic} className="img-fluid" alt={val_people.people_salutation != '' ? `${val_people.people_salutation} ${val_people.people_name}`: val_people.people_name} title={val_people.people_salutation != '' ? `${val_people.people_salutation} ${val_people.people_name}`: val_people.people_name} width="200" height="200" />
                                                :
                                                <img src={global.variables.strDomainUrl + "images/people/people-default.jpg"} className="img-fluid" alt="" title="" width="200" height="200" />
                                                }
                                            </Col>
                                            <Col md={8} className="d-flex flex-column">
                                                {
                                                    val_people.people_salutation != '' ?
                                                    <h5 className="text-dark mb-0 wow fadeInUp">{`${val_people.people_salutation} ${val_people.people_name}`}</h5>
                                                    :
                                                    <h5 className="text-dark mb-0 wow fadeInUp">{val_people.people_name}</h5>
                                                }
                                                <p className="wow fadeInUp">
                                                <span dangerouslySetInnerHTML={{ __html : val_people.people_designation}}></span>
                                                </p>
                                            </Col>
                                        </Row>
                                }
                            </Col>
                            )
                        })
                        }
                    </Row>
                </div>
                    :
                <div className="p-md-3 py-3">
                <h4 className="fw-bold mb-3 text-danger">{props.val_subcategory.ps_category_name}</h4>
                <Row className="row-cols-1 row-cols-lg-2 g-lg-4 gy-4 people">
                    {
                    peopleList?.map((val_people)=>{
                        return(
                            
                            <Col className="px-4">
                                {
                                    val_people.people_url != '' ?
                                        <Link to={val_people.people_url} target="_blank" rel="nofollow">
                                        <Row className="bg-light rounded-3 _border p-3 px-1 h-100">
                                            <Col md={4} className="mb-md-0 mb-2">
                                                {
                                                val_people.people_pic != '' && val_people.people_pic != null ?
                                                    <img src={global.variables.strApiUrl + "/people/" + val_people.people_pic} className="img-fluid" alt={val_people.people_salutation != '' ? `${val_people.people_salutation} ${val_people.people_name}`: val_people.people_name} title={val_people.people_salutation != '' ? `${val_people.people_salutation} ${val_people.people_name}`: val_people.people_name} width="200" height="200" />
                                                :
                                                    <img src={global.variables.strDomainUrl + "images/people/people-default.jpg"} className="img-fluid" alt="" title="" width="200" height="200" />
                                                }
                                            </Col>
                                            <Col md={8} className="d-flex flex-column">
                                                {
                                                    val_people.people_salutation != '' ?
                                                    <h5 className="text-dark mb-0 wow fadeInUp">{`${val_people.people_salutation} ${val_people.people_name}`}</h5>
                                                    :
                                                    <h5 className="text-dark mb-0 wow fadeInUp">{val_people.people_name}</h5>
                                                }
                                                <p className="wow fadeInUp">
                                                    <span dangerouslySetInnerHTML={{ __html : val_people.people_designation}}></span>
                                                    </p>
                                                <p className="mb-0 mt-auto wow fadeInUp">
                                                    <span className="btn btn-slide rounded-pill px-3 align-items-center d-inline-flex">
                                                    View Profile<FaLongArrowAltRight className="ms-2" />
                                                    </span>
                                                </p>
                                            </Col>
                                        </Row>
                                        </Link>
                                    :
                                        <Row className="bg-light rounded-3 _border p-3 px-1 h-100">
                                                <Col md={4} className="mb-md-0 mb-2">
                                                {
                                                    val_people.people_pic != '' ?
                                                        <img src={global.variables.strApiUrl + "/people/" + val_people.people_pic} className="img-fluid" alt={val_people.people_salutation != '' ? `${val_people.people_salutation} ${val_people.people_name}`: val_people.people_name} title={val_people.people_salutation != '' ? `${val_people.people_salutation} ${val_people.people_name}`: val_people.people_name} width="200" height="200" />
                                                    :
                                                        <img src={global.variables.strDomainUrl + "images/people/people-default.jpg"} className="img-fluid" alt="" title="" width="200" height="200" />
                                                }
                                                </Col>
                                                <Col md={8} className="d-flex flex-column">
                                                {
                                                    val_people.people_salutation != '' ?
                                                    <h5 className="text-dark mb-0 wow fadeInUp">{`${val_people.people_salutation} ${val_people.people_name}`}</h5>
                                                    :
                                                    <h5 className="text-dark mb-0 wow fadeInUp">{val_people.people_name}</h5>
                                                }
                                                <p className="wow fadeInUp">
                                                    <span dangerouslySetInnerHTML={{ __html : val_people.people_designation}}></span>
                                                </p>
                                        
                                        </Col>
                                        </Row>

                                }
                            </Col>
                            
                        )
                    })
                    }
                </Row>
                <hr className="mt-5" />
                </div>
  )
}

export default GetPeople;